import { Home, Trophy } from 'lucide-react';

const money = (value) => `$${Number(value || 0).toLocaleString()}`;

export function CareerMilestoneCelebration({ celebration, reducedMotion, busy, onContinue }) {
  if (!celebration?.pending) return null;
  return <div className={`career-milestone-overlay ${reducedMotion ? 'reduced-motion' : ''}`} role="dialog" aria-modal="true" aria-labelledby="career-milestone-title">
    <section className="career-milestone-modal glass-panel">
      <div className="career-milestone-stamp"><Home /><span>DOUBLE-WIDE</span></div>
      <span className="eyebrow">CAREER MILESTONE</span>
      <h2 id="career-milestone-title">{celebration.title || 'FROM DUMPSTER TO DOUBLE-WIDE'}</h2>
      <p>{celebration.message || 'You made it from the bottom to the top residence tier. The Career keeps going.'}</p>
      <div className="career-milestone-stats"><div><span>Day achieved</span><strong>{celebration.day}</strong></div><div><span>Net worth</span><strong>{money(celebration.netWorth)}</strong></div><div><span>Street rep</span><strong>{celebration.streetReputation}</strong></div></div>
      <button onClick={onContinue} disabled={busy}><Trophy /> Keep Climbing Street Legends</button>
    </section>
  </div>;
}
